var tokenSubject  = 'signature.client.authentication';
var tokenAudience = 'SaviScio.signature';
var tokenIssuer   = 'smartSignV2-POC'; // application name
var tokenSecret   = 'test';            // password

function submitAtosForm() {
  document.getElementById('ApplicationAuthToken').value=genToken();
  document.getElementById("signForm").submit();
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function genToken() {
  var ti = Math.round(new Date().getTime()/1000);
  var str = "{" +
    "\"iss\":\"" + tokenIssuer + "\",\r\n" +
    "\"sub\":\"" + tokenSubject + "\",\r\n" +
    "\"aud\":\"" + tokenAudience + "\" ,\r\n" +
    "\"iat\":" + ti + ",\r\n" +
    "\"exp\":" + ti + ",\r\n" +
    "\"nbf\":" + ti + ",\r\n" +
    "\"jti\":\"" + uuidv4() + "\",\r\n" +
    "\"dummyEnd\":true }";

  var hs256 = "{\"typ\":\"JWT\",\r\n \"alg\":\"HS256\"}";
  var hmacKey = tokenSecret;

  var token = new jwt.WebToken(str, hs256);
  var signed= token.serialize(hmacKey);

  return signed;
}
